import { customTv } from "#utils";

export const containerStyles = customTv({
  base: "flex items-center h-[1.25rem] w-[2.625rem] shrink-0 rounded-10 bg-clip-padding px-[3px] outline outline-1 transition duration-200 ease-in-out",
  variants: {
    isSelected: {
      false: "bg-background-primary outline-outline-input-enabled",
      true: "bg-brand-primary outline-brand-primary",
    },
    isHovered: {
      true: "",
    },
    isFocused: {
      true: "outline-2 outline-outline-brand",
    },
    isDisabled: {
      true: "cursor-not-allowed",
    },
  },
  compoundVariants: [
    // Unselected + Hovered
    {
      isSelected: false,
      isHovered: true,
      class: "outline-outline-input-hover",
    },
    // Unselected + Focused
    {
      isSelected: false,
      isFocused: true,
      class: "outline-outline-brand",
    },
    // Selected + Hovered
    {
      isSelected: true,
      isHovered: true,
      class:
        "bg-interactive-primary-button-hover-background outline-interactive-primary-button-hover-background",
    },
    // Selected + Focused
    {
      isSelected: true,
      isFocused: true,
      class:
        "bg-interactive-primary-button-focus-background outline-interactive-primary-button-focus-background",
    },
    // Disabled
    {
      isDisabled: true,
      isSelected: false,
      class: "bg-background-primary outline-interactive-disabled-outline",
    },
    {
      isDisabled: true,
      isSelected: true,
      class:
        "bg-interactive-secondary-button-focus-background outline-interactive-secondary-button-focus-background",
    },
  ],
});

export const circleStyles = customTv({
  base: "size-[.875rem] transform rounded-10 shadow-sm transition duration-200 ease-in-out",
  variants: {
    isSelected: {
      false: "translate-x-0 bg-brand-primary",
      true: "translate-x-[150%] bg-text-primary-inverse",
    },
    isDisabled: {
      true: "",
    },
  },
  compoundVariants: [
    {
      isDisabled: true,
      isSelected: false,
      class: "bg-interactive-disabled-outline",
    },
    {
      isDisabled: true,
      isSelected: true,
      class: "bg-interactive-secondary-button-hover-background",
    },
  ],
});
